import React, { useEffect, useState } from "react";
import {
  FaChevronDown,
  FaChevronRight,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import ApiServices from "../services/apiservices";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [posts, setPosts] = useState([]);
  const [allShortFalls, setallShortFalls] = useState([]);
  const [reports, setReports] = useState([]);

  const fetchPosts = async () => {
    try {
      const res = await ApiServices.getRequest(`/posts/tender-notice.php`);
      const resp = await ApiServices.getRequest(`/posts/short-level-falls.php`);
      const report = await ApiServices.getRequest(
        `/feedersreports/fetch.php?source=client`
      );
      setPosts(res.allpost || []);
      setallShortFalls(resp.allShortFalls || []);
      setReports(report.data || []);
    } catch (error) {
      console.error("Error fetching posts", error);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const navData = [
    {
      name: "ABOUT US",
      link: "/about-us",
      sub: [
        { name: "Board of Directors", link: "/board-of-directors" },
      ],
    },
    {
      name: "CUSTOMER CARE",
      link: "/customer-care",
      sub: [
        { name: "Customer Feeder Information", link: "/customer-feeder-info" },
        { name: "Customer Compensation", link: "https://compensation.beninelectric.com" },
        { name: "Tariff and Band", link: "/tariff" },
        {
          name: "Quick Complaints",
          link: "https://crm.beninelectric.com/complaints",
        },
        { name: "Track Complaints", link: "https://crm.beninelectric.com/" },
        {
          name: "Postpaid Payment",
          link: "https://quickteller.com/bedcpostpaid",
        },
        {
          name: "Prepaid Payment",
          link: "https://quickteller.com/bedcprepaid",
        },
        { name: "Other Payment Channels", link: "/e-payment-channels" },
        {
          name: "FAQs",
          link: "/faq",
          sub: [
            {
              name: "FREQUENTLY ASKED QUESTIONS ON KCT/CLEAR TAMPER ISSUE",
              link: "/faq",
            },
          ],
        },
      ],
    },
    {
      name: "RESOURCES",
      link: "#",
      sub: [
        {
          name: "HSE",
          link: "#",
          sub: [
            {
              name: "PPE Policy",
              link: "/personal-protective-equipment-ppe-policy",
            },
            {
              name: "Drug and Policy Control",
              link: "/drug-and-policy-control",
            },
            {
              name: "Occupational Health & Safety",
              link: "/occupational-health-and-safety-policy",
            },
            {
              name: "Environmental Policy",
              link: "/environmental-and-social-policy-statement",
            },
          ],
        },
        {
          name: "NERC",
          link: "#",
          sub: [
            { name: "Band A Feeders Report", sub: reports },
            { name: "Shortfalls", sub: allShortFalls },
            {
              name: "Customer Bill of Rights",
              link: "/customer-bill-of-rights-and-obligations",
            },
            {
              name: "REQUIREMENT FOR THE CONNECTION OF POINT LOAD TRANSFORMERS",
              link: "/requirement-for-the-connection-of-point-load-transformers",
            },
            { name: "BEDC MYTO order", link: "/bedc-myto-order" },
            {
              name: "New Electricity Tariff",
              link: "/new-electricity-tariff-and-customer-classification",
            },
          ],
        },
        {
          name: "BEDC Audited Financial Statements",
          link:"/category/bedc-audited-financial-statements"
        }
      ],
    },
    {
      name: "METERING",
      link: "/metering",
      sub: [
        { name: "MAP Meter Prices", link: "/category/map-meter-prices" },
        {
          name: "Order a meter",
          link: "https://imaap.beninelectric.com",
        },
        {
          name: "Contractors’ Portal",
          link: "https://netapp.beninelectric.com",
        },
      ],
    },
    {
      name: "PUBLICATIONS",
      link: "/publications",
      sub: [
        { name: "Corporate Communications", link: "/corporate-communications" },
        { name: "Tender Notice", link: "#", sub: posts },
      ],
    },  
    { name: "CAREERS", link: "/careers" },  
    { name: "CONTACT", link: "/contact" },
  ];

  const DesktopMenuItem = ({ item }) => (
    <div className="group relative h-full flex items-center">
      <a href={item.link} className="h-full flex items-center">
        <button className="px-2.5 lg:px-3.5 py-6 text-xs lg:text-sm font-bold text-gray-900 hover:bg-green-800 hover:text-white transition-colors flex items-center gap-1 uppercase tracking-wider whitespace-nowrap">
          {item.name}{" "}
          {item.sub && (
            <FaChevronDown size={10} className="mt-0.5 opacity-70 flex-shrink-0" />
          )}
        </button>
      </a>

      {item.sub && (
        <div className="absolute top-full left-0 w-64 bg-white hidden group-hover:block shadow-2xl animate-fade-in z-50 border-t-2 border-green-700">
          {item.sub.map((subItem) => (
            <div
              key={subItem.name}
              className="relative group/level2 border-b border-gray-100 last:border-0"
            >
              <a
                href={subItem.link}
                className="flex justify-between items-center px-6 py-4 text-[13px] text-gray-800 hover:bg-green-700 hover:text-white transition-all"
              >
                {subItem.name}
                {subItem.sub && <FaChevronRight size={10} />}
              </a>
              {subItem.sub && (
                <div className="absolute left-full top-0 w-64 bg-white hidden group-hover/level2:block shadow-2xl border-l border-gray-100 z-20">
                  {subItem.sub.map((child) => (
                    <DesktopMenuItemChild key={child.name} item={child} />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const DesktopMenuItemChild = ({ item }) => (
    <div className="relative group/level3 border-b border-gray-100 last:border-0">
      <a
        href={item.link}
        className="flex justify-between items-center px-6 py-4 text-[13px] text-gray-800 hover:bg-green-700 hover:text-white transition-all"
      >
        {item.name}
        {item.sub && <FaChevronRight size={10} />}
      </a>
      {item.sub && (
        <div className="absolute left-full top-0 w-64 bg-white hidden group-hover/level3:block shadow-2xl border-l border-gray-100 z-30">
          {item.sub.map((deepChild) => (
            <DesktopMenuItemChildChild key={deepChild.name} item={deepChild} />
          ))}
        </div>
      )}
    </div>
  );

  const DesktopMenuItemChildChild = ({ item }) => (
    <div className="relative group/level4 border-b border-gray-100 last:border-0">
      <a
        href={item.link}
        className="flex justify-between items-center px-6 py-4 text-[13px] text-gray-800 hover:bg-green-700 hover:text-white transition-all"
      >
        {item.name}
        {item.sub && <FaChevronRight size={10} />}
      </a>
      {item.sub && (
        <div className="absolute left-full top-0 w-64 bg-white hidden group-hover/level4:block shadow-2xl border-l border-gray-100 z-30">
          {item.sub.map((deepChild) => (
            <a
              key={deepChild.name}
              href={deepChild.link}
              className="block px-6 py-4 text-[13px] text-gray-800 hover:bg-green-700 hover:text-white border-b border-gray-100 transition-all"
            >
              {deepChild.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
  
  const MobileMenuItem = ({ item, closeMenu }) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasSub = item.sub && item.sub.length > 0;

    const handleClick = (e) => {
      if (hasSub && item.link && item.link !== "#") {
        // If it has sub-items and a valid link, let clicking toggle the dropdown first, 
        // or handle it based on preference. To make direct links functional:
        // Let's toggle dropdown if user clicks the arrow container, but navigate if clicking text, 
        // OR standard accordion toggle.
      }
    };

    return (
      <div className="text-gray-800 bg-white">
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-white hover:bg-gray-50">
          {/* Main link functionality for mobile */}
          <a
            href={item.link && item.link !== "#" ? item.link : undefined}
            onClick={() => {
              if (!hasSub && (!item.link || item.link === "#")) return;
              if (!hasSub) {
                closeMenu();
              }
            }}
            className="text-sm font-semibold flex-grow cursor-pointer"
          >
            {item.name}
          </a>

          {/* Toggle button for submenus */}
          {hasSub && (
            <div
              className="p-2 cursor-pointer text-green-700"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <FaChevronDown size={14} /> : <FaChevronRight size={14} />}
            </div>
          )}
        </div>

        {hasSub && isOpen && (
          <div className="bg-gray-50 pl-4">
            {item.sub.map((sub) => (
              <MobileMenuItem key={sub.name} item={sub} closeMenu={closeMenu} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="bg-white font-sans">
      {/* 1. TOP INFO BAR */}
      <div className="hidden lg:flex justify-between items-center px-10 py-5 bg-white border-b border-gray-100">
        <div className="flex items-center">
          <a href="/">
            <img src="/images/BEDCLogo.png" alt="BEDC Logo" className="h-10" />
          </a>
        </div>
      </div>

      {/* 2. MAIN NAV BAR */}
      <nav className="bg-yellow-400 text-white sticky top-0 z-50 shadow-md">
        <div className="max-w-[1400px] mx-auto px-4 lg:px-10">
          <div className="flex justify-between items-center h-16 lg:h-13">
            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center h-full">
              {navData.map((item) => (
                <DesktopMenuItem key={item.name} item={item} />
              ))}
            </div>

            {/* Support Phone Number */}
            <div className="hidden lg:flex items-center space-x-3 bg-green-800 px-4 py-2 rounded-full border border-green-600 shadow-inner flex-shrink-0">
              <div className="leading-tight text-right">
                <p className="text-base tracking-tight">07000002332</p>
                <p className="text-[9px] font-bold opacity-75 uppercase tracking-widest">
                  Customer Care
                </p>
              </div>
              <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center text-green-700 font-bold text-xs">
                ☏
              </div>
            </div>

            {/* Mobile Header */}
            <div className="lg:hidden flex justify-between w-full items-center">
              <a href="/">
                <img
                  src="/images/BEDCLogo.png"
                  alt="BEDC Logo"
                  className="h-10"
                />
              </a>
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 bg-green-800 rounded-md text-white"
              >
                {isMobileMenuOpen ? (
                  <FaTimes size={20} />
                ) : (
                  <FaBars size={20} />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Panel */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 max-h-[85vh] overflow-y-auto shadow-xl">
            {navData.map((item) => (
              <MobileMenuItem
                key={item.name}
                item={item}
                closeMenu={() => setIsMobileMenuOpen(false)}
              />
            ))}

            <div className="px-6 py-8 border-t border-gray-100 bg-gray-50">
              <div className="flex items-center space-x-4 mb-6">
                <div className="bg-green-700 p-3 rounded-full text-white">
                  <FaPhoneAlt />
                </div>
                <div>
                  <p className="text-xl font-bold text-gray-900">07000002332</p>
                  <p className="text-xs text-gray-500 uppercase font-bold tracking-widest">
                    24/7 Support
                  </p>
                </div>
              </div>
              <button className="w-full bg-green-800 text-white font-black py-4 rounded-xl shadow-lg hover:bg-green-900 transition-all uppercase tracking-widest">
                Call Support Now
              </button>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

const FaPhoneAlt = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"></path>
  </svg>
);

export default Navbar;